import React, { useState } from 'react';
import DefaultLayout from '../../../layouts/defaultLayout';
import { search } from '../../../assets/svgIcons';
import axios from 'axios';
import { BASE_URL } from '../../../constants';
import { userData } from '../../../data/fake_login_data';
import { ToastContainer, toast } from 'react-toastify';
import { Loader, Toggle } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import Modal from '../../../components/modal';

const Enquiry = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState(null);
  const [data, setData] = useState(null);
  const [type, setType] = useState(1);
  const [loading, setLoading] = useState(false);
  const [revoke, setRevoke] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        BASE_URL + "subscriptions/cards/check_card.php",
        {
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
          code: searchValue,
          type: type ? "id" : "code",
        }
      );

      if (response?.data?.status == "success") {
        response.data.message.used_success =
          response.data.message.card_used == 1 ? 1 : 0;
        response.data.message.card_used =
          response.data.message.card_used == 1 ? "مستخدم" : "غير مستخدم";

        // delete response.data.message.student_id;
        delete response.data.message.card_used_for;
        delete response.data.message.courses_ids;
        setData(response?.data?.message);
      } else {
        toast.error("Card Not Found");
        setData([]);
      }
      setLoading(false);
    } catch (err) {
      setData([]);
      toast.error(err?.message);
      setLoading(false);
    }
  };

  const makeUsed = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        revoke?.type == "reset"
          ? BASE_URL + "subscriptions/cards/reset_card.php"
          : revoke?.type == "stop"
          ? BASE_URL + "subscriptions/cards/stop_card.php"
          : null,
        {
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
          ...revoke,
        }
      );

      if (response.data?.status == "success") {
        toast.success(response.data?.message);
        fetchData();
        setRevoke(false);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.data?.message);
      }

      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };

  const hiddenArr = ["used_success"];

  return (
    <div id="home" className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <DefaultLayout
        children={
          <div className="max-w-9xl mx-auto bg-white rounded-2xl shadow-xl p-8">
            <h4 className="text-2xl font-bold text-indigo-800 mb-6 text-center">Enquiries</h4>
            <div className="flex items-center justify-center gap-4 mb-6">
              <span className="text-lg font-medium text-gray-700">By Card Code</span>
              <Toggle 
                checked={type} 
                onChange={(e) => setType(e)} 
                className="scale-125"
              />
              <span className="text-lg font-medium text-gray-700">By Card Id</span>
            </div>
            <div className="flex items-center gap-4 mb-8">
              <div className="flex-1 relative">
                <label htmlFor="search" className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  {search}
                </label>
                <input
                  type="search"
                  id="search"
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                  }}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  placeholder="Enter card code or ID..."
                />
              </div>
              <button
                className="px-6 py-3 bg-indigo-600 text-white font-bold rounded-lg shadow-md hover:bg-indigo-700 hover:shadow-lg transition duration-300 transform hover:-translate-y-1 flex items-center justify-center"
                onClick={() => (!loading ? fetchData() : null)}
              >
                {!loading ? "Search" : <Loader />}
              </button>
            </div>

            <div className="cardData">
              {data && data?.card_id ? (
                <>
                  <div className="flex justify-end gap-4 mb-6">
                    <button
                      className="px-6 py-2 bg-red-500 text-white font-bold rounded-lg shadow-md hover:bg-red-600 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
                      // disabled={data?.used_success == 0}
                      onClick={() => {
                        setRevoke({
                          card_id: data?.card_id,
                          type: "reset",
                        });
                      }}
                    >
                      {!loading ? "Reset" : <Loader />}
                    </button>
                    <button
                      className="px-6 py-2 bg-red-500 text-white font-bold rounded-lg shadow-md hover:bg-red-600 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
                      // disabled={data?.used_success == 1}
                      onClick={() => {
                        setRevoke({
                          card_id: data?.card_id,
                          type: "stop",
                        });
                      }}
                    >
                      {!loading ? "Stop" : <Loader />}
                    </button>
                  </div>
                  <div className="overflow-x-auto rounded-lg shadow-md">
                    <table className="min-w-full divide-y divide-gray-200">
                      <tbody className="bg-white divide-y divide-gray-200">
                        {data
                          ? Object.keys(data)?.map((item) => {
                              if (
                                !hiddenArr.filter((h_item) => h_item == item)
                                  ?.length
                              )
                                return (
                                  <tr key={item} className="hover:bg-indigo-50 transition duration-200">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 capitalize">{item.replace(/_/g, ' ')}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                      <div className="flex items-center gap-4">
                                        {item == "student_name" &&
                                        data?.student_id > 0 ? (
                                          <a
                                            className="px-4 py-2 bg-indigo-500 text-white font-medium rounded-md shadow hover:bg-indigo-600 transition duration-200"
                                            href={
                                              "/profile?stu_id=" +
                                              data?.student_id
                                            }
                                            style={{ textDecoration: "none" }}
                                            target="_blank"
                                          >
                                            Show Profile
                                          </a>
                                        ) : null}
                                        <span>{data[item]}</span>
                                      </div>
                                    </td>
                                  </tr>
                                );
                            })
                          : null}
                      </tbody>
                    </table>
                  </div>
                </>
              ) : null}
            </div>
            <Modal
              open={revoke}
              toggle={setRevoke}
              headerTitle={"Card Reset"}
              children={
                <>
                  <h5 className="text-lg font-semibold text-gray-800 mb-4 text-center">Are You Sure To Continue?</h5>
                  <div className="flex justify-center gap-4">
                    <button
                      className="px-6 py-2 bg-red-500 text-white font-bold rounded-lg shadow-md hover:bg-red-600 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
                      onClick={() => {
                        return !loading ? makeUsed() : null;
                      }}
                    >
                      {!loading ? "Yes" : <Loader />}
                    </button>
                    <button
                      className="px-6 py-2 bg-indigo-600 text-white font-bold rounded-lg shadow-md hover:bg-indigo-700 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
                      onClick={() => {
                        setRevoke(false);
                      }}
                    >
                      No
                    </button>
                  </div>
                </>
              }
            />
          </div>
        }
      />
      <ToastContainer />
    </div>
  );
};

export default Enquiry;